import React, {useCallback, useContext, useEffect, useState} from 'react'
import {useHttp} from '../hooks/http.hook'
import {AuthContext} from '../context/AuthContext'
import config from '../config.json'
import {getAuthHeader, objectLang, removeCookieOfFolderId, setErrorWindow} from "../functions"
import {ModalWin} from "./ModalWin"
import {LoaderClass} from "./LoaderClass"

export const SaveNewNote = ({note}) => {

    const l = objectLang().language.lang
    const auth = useContext(AuthContext)
    const [allowed, setAllowed] = useState(true)
    const [dataModal, setDataModal] = useState({})
    const {request, loading} = useHttp()

    const getData = useCallback(async () => {
        let host
        window.location.host === 'localhost:3000' ? host = config.localHost : host = config.onrender
        try {
            const data = await request(
                `${host}/api/note/create`,
                'POST',
                {
                    userId: auth.userId,
                    parentFolder: note.parentFolder,
                    name: note.name,
                    body: note.body
                },
                {
                    Authorization: getAuthHeader(auth)
                })
            if (data.status !== 201) {
                setAllowed(false)
                setDataModal(setErrorWindow('', data.code))
            } else {
                removeCookieOfFolderId(note.parentFolder)
                window.location.replace(`/${l}/folder/open/${note.parentFolder}`)
            }

        } catch (e) {
            window.location.replace(`/${l}/`)
        }
    }, [auth, request, note, l])

    useEffect(() => {
        getData().then()
    }, [getData])

    if (loading) {
        return <LoaderClass />
    }

    if (!allowed) {
        return (
            <>
                <ModalWin data={dataModal}/>
            </>

        )
    }
}
